import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.url.startsWith(environment.externalUrls.bff) || request.url.startsWith(environment.externalUrls.pipeline)) {
      const cloned = request.clone({ withCredentials: true });
      return next.handle(cloned);
    }

    return next.handle(request);
  }
}
